import { OptionI } from '@/utils/forms/optionBuilders'
import { getOptionsArray } from '@/utils/forms/optionHelpers'

import { GuardsFormInputs } from '../types/guardActionTypes'

export const isSpecificGuardOption = (option: OptionI) =>
  option?.value !== null && option?.value !== undefined

// Constructs dispatchedGuardIds array for GraphQL mutation based on form inputs
export const getDispatchedGuardIds = (values: GuardsFormInputs) =>
  getOptionsArray(values?.guards)
    .filter(isSpecificGuardOption)
    .map((o) => o.value)
